
import ProMarketplaceLandingPageStoreName from '@/store/pro-marketplace-home/name';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import LazyImage from '@/components/lazy-image';
import { Comparator } from '@/ui-kit/enums';
import { Breakpoints } from '@/ui-kit/styles/constants';

export default {
  name: 'ProMarketplaceLandingPageHeroSection',
  components: {
    Typography,
    LazyImage,
  },
  data() {
    return {
      TypographyType,
      StyleColorSchemeType,
    };
  },
  computed: {
    content() {
      return this.$store.state[ProMarketplaceLandingPageStoreName].heroContent;
    },
    heroImageSizes() {
      return [
        {
          comparator: Comparator.Less,
          breakpoint: Breakpoints.Medium,
          imageSize: 930,
        },
        {
          comparator: Comparator.Greater,
          breakpoint: Breakpoints.Medium,
          imageSize: 430,
        },
      ];
    },
  },
};
